var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("\n    Freundschaftsanfrage\n  ")]),_vm._v(" "),_vm._l((_vm.attributeErrors),function(error,index){return (_vm.hasErrors)?_c('div',{key:index,staticClass:"invalid-feedback"},_vm._l((error),function(e){return _c('div',{key:e},[_vm._v("\n      "+_vm._s(e)+"\n    ")])}),0):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }